import { useState, useEffect } from "react";

type Weather = {
  temp: number;
  condition: string;
};

const WMO_CODES: Record<number, string> = {
  0: "Clear",
  1: "Mostly Clear",
  2: "Partly Cloudy",
  3: "Overcast",
  45: "Foggy",
  48: "Foggy",
  51: "Drizzle",
  53: "Drizzle",
  55: "Drizzle",
  61: "Rain",
  63: "Rain",
  65: "Heavy Rain",
  71: "Snow",
  73: "Snow",
  75: "Heavy Snow",
  77: "Snow Grains",
  80: "Showers",
  81: "Showers",
  82: "Heavy Showers",
  85: "Snow Showers",
  86: "Snow Showers",
  95: "Thunderstorm",
  96: "Thunderstorm",
  99: "Thunderstorm",
};

export function useWeather() {
  const [weather, setWeather] = useState<Weather | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchWeather = async (lat: number, lon: number) => {
      try {
        const res = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,weather_code&temperature_unit=fahrenheit`
        );
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        const temp = Math.round(data.current.temperature_2m);
        const code = data.current.weather_code as number;
        setWeather({ temp, condition: WMO_CODES[code] || "Unknown" });
      } catch {
        // Silent fail — weather is nice-to-have
      }
    };

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => fetchWeather(pos.coords.latitude, pos.coords.longitude),
        () => fetchWeather(33.45, -112.07) // Phoenix fallback
      );
    } else {
      fetchWeather(33.45, -112.07);
    }

    return () => { cancelled = true; };
  }, []);

  return weather;
}
